import * as React from "react";
import { Avatar, Button, Flex, Image, Segment, Text } from "@fluentui/react-northstar";
import { withTranslation, WithTranslation } from "react-i18next";
import { CommonHelper } from '../../../helpers/common-helper';

const moment = require('moment');

interface IQueueScheduledProps extends WithTranslation {
    botWriting: boolean;
    ancora: string;
    meetingData: any;
    meetingQueueData: any;
    appConfigs: any;
    appSettings: any;
    daysOfWeekLocale: any;
}

const QueueScheduledCard: React.FunctionComponent<IQueueScheduledProps> = props => {
    const localize = props.t;

    return (
        <React.Fragment>
            {!props.meetingQueueData.scheduleDay && !props.meetingQueueData.scheduleExpired &&
                <Flex gap="gap.medium" className="firstCard card" styles={{ margin: "4rem 0" }}>
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Image hidden={!props.botWriting} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text className="header-text" content={`O seu atendimento está agendado!`} />
                                    <span className="header-subtext">{localize('ProtocoloAtendimento')} <span className="highlight">#{props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}</span></span>

                                    <Flex hAlign="center" className="welcome-queue">
                                        {props.appConfigs && props.appConfigs.imgWelcome != "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image src={props.appConfigs.imgWelcome} />
                                            </Flex.Item>
                                        }

                                        {props.appConfigs && props.appConfigs.imgWelcome == "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image src="https://studio365cdn.azureedge.net/balcaovirtual/expired.svg" />
                                            </Flex.Item>
                                        }
                                    </Flex>

                                    <Flex gap="gap.medium" column>
                                        <Flex gap="gap.small" column>
                                            <Text weight="light" size="medium" content={`O dia e horário do seu atendimento é: ${moment(props.meetingQueueData.schedule).format("DD/MM/YYYY HH:mm")}`} />
                                        </Flex>
                                    </Flex>

                                    <Flex gap="gap.small">
                                        {props.appSettings && props.appSettings.ajudaComoFunciona &&
                                            <Button content={localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaComoFunciona), "_blank")} />
                                        }

                                        {props.appSettings && props.appSettings.ajudaPerguntasFrequentes &&
                                            <Button content={localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                        }
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }
            
            {props.meetingQueueData.scheduleExpired &&
                <Flex gap="gap.medium" className="firstCard card" styles={{ margin: "4rem 0" }}>
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Image hidden={!props.botWriting} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text className="header-text" content={`O seu agendamento foi expirado!`} />
                                    <span className="header-subtext">{localize('ProtocoloAtendimento')} <span className="highlight">#{props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}</span></span>

                                    <Flex hAlign="center" className="welcome-queue">
                                        {props.appConfigs && props.appConfigs.imgWelcome != "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image src={props.appConfigs.imgWelcome} />
                                            </Flex.Item>
                                        }

                                        {props.appConfigs && props.appConfigs.imgWelcome == "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image src="https://studio365cdn.azureedge.net/balcaovirtual/expired.svg" />
                                            </Flex.Item>
                                        }
                                    </Flex>

                                    <Flex gap="gap.medium" column>
                                        <Flex gap="gap.small" column>
                                            <Text
                                                weight="light"
                                                size="medium"
                                                content={`O seu agendamento do dia ${moment(props.meetingQueueData.schedule).format("DD/MM/YYYY HH:mm")} foi expirado.`}
                                            />
                                        </Flex>
                                    </Flex>

                                    <Flex gap="gap.small">
                                        {props.appSettings && props.appSettings.ajudaComoFunciona &&
                                            <Button content={localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaComoFunciona), "_blank")} />
                                        }

                                        {props.appSettings && props.appSettings.ajudaPerguntasFrequentes &&
                                            <Button content={localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                        }
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }

            {(props.meetingQueueData.scheduleDay && !props.meetingQueueData.scheduleExpired && !props.meetingQueueData.scheduleDayInRange) &&
                <Flex gap="gap.medium" className="firstCard card" styles={{ margin: "4rem 0" }}>
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Image hidden={!props.botWriting} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text weight="bold" size="large" content={`O seu atendimento está próximo!`} />
                                    <span className="header-subtext">{localize('ProtocoloAtendimento')} <span className="highlight">#{props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}</span></span>

                                    <Flex hAlign="center" className="welcome-queue">
                                        {props.appConfigs && props.appConfigs.imgWelcome != "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image src={props.appConfigs.imgWelcome} />
                                            </Flex.Item>
                                        }

                                        {props.appConfigs && props.appConfigs.imgWelcome == "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image src="https://studio365cdn.azureedge.net/balcaovirtual/expired.svg" />
                                            </Flex.Item>
                                        }
                                    </Flex>

                                    <Flex gap="gap.medium" column>
                                        <Flex gap="gap.small" column>
                                            <Text weight="light" size="medium" content={`Você tem um agendamento na data de hoje, aguarde o atendimento.`} />
                                            <Text weight="light" size="medium" content={`Horário de atendimento: ${moment(props.meetingQueueData.schedule).format("HH:mm")}`} />
                                        </Flex>
                                    </Flex>

                                    <Flex gap="gap.small">
                                        {props.appSettings && props.appSettings.ajudaComoFunciona &&
                                            <Button content={localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaComoFunciona), "_blank")} />
                                        }

                                        {props.appSettings && props.appSettings.ajudaPerguntasFrequentes &&
                                            <Button content={localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                        }
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }

            {(props.meetingQueueData.scheduleDay && props.meetingQueueData.scheduleDayInRange) &&
                <Flex gap="gap.medium" className="firstCard card" styles={{ margin: "4rem 0" }}>
                    <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                    <Image hidden={!props.botWriting} className="typing" src="https://studio365cdn.azureedge.net/balcaovirtual/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting}
                            className="dialog2 dialog"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text className="header-text" content={`O seu agendamento está no horário!`} />
                                    <span className="header-subtext">{localize('ProtocoloAtendimento')} <span className="highlight">#{props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}</span></span>

                                    <Flex hAlign="center" className="welcome-queue">
                                        <Flex.Item align="center" className="welcome">
                                            <Image src="https://studio365cdn.azureedge.net/balcaovirtual/expired.svg" />
                                        </Flex.Item>
                                    </Flex>

                                    <Flex gap="gap.medium" column>
                                        <Flex gap="gap.small" column>
                                            <Text weight="light" size="medium" content={`Fique atento, você será atendido em instantes`} />
                                            <Text weight="light" size="medium" content={`Horário do agendamento: ${moment(props.meetingQueueData.schedule).format("HH:mm")}`} />
                                        </Flex>
                                    </Flex>

                                    <Flex gap="gap.small">
                                        {props.appSettings && props.appSettings.ajudaComoFunciona &&
                                            <Button content={localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaComoFunciona), "_blank")} />
                                        }

                                        {props.appSettings && props.appSettings.ajudaPerguntasFrequentes &&
                                            <Button content={localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                        }
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }
        </React.Fragment>
    );
};

const queueScheduledWithTranslation = withTranslation()(QueueScheduledCard);
export default queueScheduledWithTranslation;